<template>
  <v-container>
    <h1>รายละเอียดข้อมูล</h1>
    <!-- <pre>{{ created_word }}</pre> -->
    <v-form ref="form">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="10" class="py-0">
          <v-row>
            <v-col cols="12" class="py-0">
              <span class="text_body_7">ความหมาย</span>
              <v-text-field
                v-model="created_word.mean"
                dense
                outlined
                single-line
                placeholder="ระบุความหมาย"
                :readonly="read_mode"
              ></v-text-field
            ></v-col>
            <v-col cols="12" class="py-0">
              <span class="text_body_7">หมวดหมู่คำ</span>
              <v-autocomplete
                v-model="created_word.categoryId"
                outlined
                :items="category_list"
                dense
                item-text="categoryName"
                item-value="categoryId"
                single-line
                placeholder="ค้นหาหมวดหมู่"
                :rules="rule_empty_Dropdown"
                :readonly="read_mode"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-card
                class="mb-5"
                outlined
                v-for="(item, index) in created_word.subLanguage"
                :key="index"
              >
                <v-container>
                  <v-row align="center" justify="center">
                    <v-col cols="12" sm="11" md="10" class="py-0">
                      <v-row>
                        <v-col cols="12">
                          <v-avatar
                            tile
                            size="36"
                            v-if="item"
                            style="margin-top:-8px"
                          >
                            <v-img
                              v-if="getLanguageFlag(item.languageId)"
                              :src="
                                require('@/assets/flag/' +
                                  getLanguageFlag(item.languageId))
                              "
                            ></v-img>
                          </v-avatar>
                          <span
                            v-if="getLanguageName(item.languageId)"
                            class="primary--text ml-2  text_body_6"
                            >{{ getLanguageName(item.languageId) }}</span
                          >
                        </v-col>

                        <v-col cols="12" class="py-0">
                          <v-row justify="center" align="center">
                            <v-col cols="10" class="py-0">
                              <span class="text_body_7">อักษรพิเศษ</span>
                              <v-text-field
                                v-model="item.alphabet"
                                dense
                                outlined
                                single-line
                                placeholder="อักษรพิเศษ"
                                :rules="rule_empty_textField"
                                :readonly="read_mode"
                              ></v-text-field>
                            </v-col>
                            <v-spacer></v-spacer>
                            <!-- <v-col cols="2">
                            <v-btn icon @click=""
                              ><v-icon>mdi-plus-circle</v-icon></v-btn
                            >
                          </v-col> -->
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          class="py-0"
                          v-for="(transcription, i) in item.transcriptionList"
                          :key="i"
                        >
                          <v-row justify="center" align="center">
                            <v-col cols="10" class="py-0">
                              <span class="text_body_7">คำทับศัพท์</span>
                              <v-text-field
                                v-model="transcription.transcriptionName"
                                dense
                                outlined
                                single-line
                                :placeholder="'คำทับศัพท์ที่ ' + (i + 1)"
                                :rules="rule_empty_textField"
                                :readonly="read_mode"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2" class="py-0">
                              <v-row>
                                <v-btn
                                  :disabled="read_mode"
                                  :small="mobile"
                                  v-if="i == item.transcriptionList.length - 1"
                                  icon
                                  @click="addTranscription(index)"
                                  ><v-icon :small="mobile"
                                    >mdi-plus-circle</v-icon
                                  ></v-btn
                                >
                                <v-btn
                                  :disabled="read_mode"
                                  v-if="i != 0"
                                  icon
                                  :small="mobile"
                                  @click="delTranscription(index, i)"
                                  ><v-icon :small="mobile"
                                    >mdi-minus-circle</v-icon
                                  ></v-btn
                                >
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row></v-container
                ></v-card
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import * as rules from "../../../assets/javascript/rules";
export default {
  data() {
    return {
      selected: [],
      rule_empty_textField: rules.isEmptyTextField,
      rule_empty_Dropdown: rules.isEmptyDropdown,
      // rule_mean: [(v) => /^\S+(\s\S+)*$/.test(v) || "กรุณาเว้นวรรคให้ถูกต้อง"],
    };
  },
  mounted() {
    this.$emit("validate", this.$refs.form);
  },
  created() {},
  computed: {
    read_mode() {
      return this.$store.state.moduleCreateEditWord.createMode == "read"
        ? true
        : false;
    },
    created_word() {
      return this.$store.state.moduleCreateEditWord.created_word;
    },
    selected_language() {
      return this.$store.state.moduleCreateEditWord.selected_language;
    },
    category_list() {
      return this.$store.state.moduleCreateEditWord.category_list;
    },
    language_list() {
      return this.$store.state.moduleCreateEditWord.language_list;
    },
    all_language() {
      var all = [];
      this.language_list.forEach((element) => {
        all.push(element.languageId);
      });
      return all;
    },
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    selected(val) {
      var new_selected = val;
      var selected = [];
      var created = [];
      //   new_selected.forEach((element) => {
      //     console.log(element);
      //   });
      if (
        this.$store.state.moduleCreateEditWord.created_word.subLanguage.length >
        0
      ) {
        this.$store.state.moduleCreateEditWord.created_word.subLanguage.forEach(
          (element) => {
            created.push(element.languageId);
          }
        );
        new_selected.forEach((e1) => {
          var includes = created.includes(e1);
          // console.log(includes);
          if (includes == false) {
            this.$store.state.moduleCreateEditWord.created_word.subLanguage.push(
              {
                languageId: e1,
                languageName: this.getLanguageName(e1),
                languagePathImg: this.getLanguageFlag(e1),
                alphabet: "",
                rule: "",
                transcriptionList: [{ transcriptionName: "" }],
                subLanguageStatus: this.$store.state.moduleCreateEditWord
                  .btn_public
                  ? "active"
                  : "pending",
              }
            );
          }
        });
        created.forEach((element, index) => {
          var includes = new_selected.includes(element);
          //   console.log(includes);
          if (includes == false) {
            this.$store.state.moduleCreateEditWord.created_word.subLanguage.splice(
              index,
              1
            );
          }
        });
      } else {
        // console.log(new_val[0]);
        this.$store.state.moduleCreateEditWord.created_word.subLanguage.push({
          languageId: new_val[0],
          languageName: this.getLanguageName(new_val[0]),
          languagePathImg: this.getLanguageFlag(new_val[0]),
          alphabet: "",
          rule: "",
          transcriptionList: [{ transcriptionName: "" }],
          subLanguageStatus: this.$store.state.moduleCreateEditWord.btn_public
            ? "active"
            : "pending",
        });
      }
    },
  },
  methods: {
    getLanguageName(id) {
      var language_name = "";
      this.language_list.forEach((element) => {
        if (element.languageId == id) {
          language_name = element.languageName;
        }
      });
      return language_name;
    },
    getLanguageFlag(id) {
      var language_flag = "";
      this.language_list.forEach((element) => {
        if (element.languageId == id) {
          language_flag = element.languagePathImg;
        }
      });
      return language_flag;
    },
    addTranscription(sub_index) {
      this.created_word.subLanguage[sub_index].transcriptionList.push({
        transcriptionName: "",
      });
    },
    delTranscription(sub_index, transcription_index) {
      this.created_word.subLanguage[sub_index].transcriptionList.splice(
        transcription_index,
        1
      );
    },
    remove(item) {
      //   console.log(item);

      var index = this.selected.indexOf(item.languageId);
      //   console.log(index);

      if (index >= 0) {
        this.selected.splice(index, 1);
      }
    },

    delSubLanguage(id) {
      var index = this.selected.indexOf(id);
      this.selected.splice(index, 1);
    },
  },
};
</script>
